import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) {
      setMessage(error.message);
    } else {
      setMessage('Connexion réussie !');
      navigate('/Commandes');
    }
  };

  return (
    <div className="container-scroller">
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="row w-100 m-0">
          <div className="content-wrapper full-page-wrapper d-flex align-items-center auth login-bg">
            <div className="card col-lg-4 mx-auto">
              <div className="card-body px-5 py-5">
                <h3 className="card-title text-left mb-3">Login</h3>
                <form onSubmit={handleLogin}>
                  <div className="form-group">
                    <label>Email *</label>
                    <input
                      type="email"
                      placeholder="Email" 
                      className="form-control p_input"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Mot de passe *</label>
                    <input
                      type="password"
                      placeholder="Mot de passe" 
                      className="form-control p_input"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
 {/* 
                  <div className="form-group d-flex align-items-center justify-content-between">
                    <div className="form-check">
                      <label className="form-check-label">
                        <input type="checkbox" className="form-check-input" /> Remember me
                      </label>
                    </div>
                    <a href="#" className="forgot-pass">Forgot password</a>
                  </div>
  */}
                  <div className="text-center">
                    <button type="submit" className="btn btn-primary btn-block enter-btn">Login</button>
                  </div>
                  <div className="d-flex mt-2">
                    <button type="button" className="btn btn-facebook mr-2 col">
                      <i className="mdi mdi-facebook"></i> Facebook
                    </button>
                    <button type="button" className="btn btn-google col">
                      <i className="mdi mdi-google-plus"></i> Google plus
                    </button>
                  </div>
                  {/*  <p className="sign-up mt-3">
                    Pas de compte? <Link to="/Signup"> Inscrivez-vous</Link>
                  </p>  */}
                  <p className="text-danger mt-2">{message}</p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;


